<!--  -->
<template>
	<div class="" id="login">
		<bar></bar>
		
		<div class="center-box">
			<div class="title">用户登录</div>
			<div class="login-div flex">
				<p class="login-text"><span>*</span>手机号：</p>
				<div class="login-input">
					<el-input v-model="phone" placeholder="请输入手机号"></el-input>
				</div>
			</div>
			<div class="login-div login-div2 flex">
				<p class="login-text"><span>*</span>登录密码：</p>
				<div class="login-input">
					<el-input v-model="password" placeholder="请输入密码" show-password></el-input>
				</div>
			</div>
			<div class="login-div login-div2 flex">
				<p class="login-text"></p>
				 <el-button type="primary" style="width: 180px;background-color: #e60012;border-color: #e60012;" @click="open" >登录</el-button>
			</div>
			
		</div>
	</div>
</template>

<script>
	
	// import { getCode, toLogin } from "@/api/Login";
	
	// import { API_PATH } from "@/utils/env"
	
	export default {
		data() {
			return {
				username: '',
				phone:'',
				password:'',
			}
		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {
			
		},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {
			let that = this;
			// that.getCode();
		},
		methods: {
			open() {
				this.$alert('登录名和密码错误', '信息', {
				  confirmButtonText: '确定',
				  callback: action => {
					// this.$message({
					//   type: 'info',
					//   message: `action: ${ action }`
					// });
				  }
				});
			}
			
		},
	}
</script>
<style scoped>
	.center-box{
		position: relative;
		width: 800px;
		height: 312px;
		border: 1px solid #d2d2d2;
		border-radius: 3px;
		margin: 50px auto;
	}
	.center-box .title{
		width: 120px;
		height: 45px;
		background-color: #e60012;
		position: absolute;
		top: 20px;
		left: -2px;
		text-align: center;
		line-height: 45px;
		color: #FFFFFF;
	}
	.login-div{
		width: 340px;
		margin: 80px auto 0;
		
	}
	.login-div2{
		margin: 20px auto 0;
	}
	.login-text{
		width: 100px;
		text-align: right;
	}
	.login-text span{
		color: red;
	}
	.login-input{
		width: 210px;
	}
	.login-btn{
		padding-top: 30px;
		justify-content: center;
	}
</style>
